module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_4_3_w_1477.5010a29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1477.jpg
// module id = AD/q
// module chunks = 0